var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_c('img',{staticStyle:{"width":"40px","height":"40px","object-fit":"cover","border":"0 none","border-radius":"1000px"},attrs:{"src":`${this.data.picture}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }